import moment from 'moment/moment';
import { useState } from 'react';

const useFilters = () => {
  const [periodo, setPeriodo] = useState([
    moment().subtract(1000, 'days'),
    moment(),
  ]);
  const [produto, setProduto] = useState({
    id: 0,
    value: 'Todos',
  });
  const [cidade, setCidade] = useState({
    id: 0,
    value: 'Todas',
  });
  const [estado, setEstado] = useState({
    id: 0,
    value: 'Todos',
  });

  const handlePeriodo = value => setPeriodo(value);
  const handleProduto = value => setProduto(value);
  const handleCidade = value => setCidade(value);
  const handleEstado = value => setEstado(value);

  return {
    periodo,
    handlePeriodo,
    produto,
    handleProduto,
    cidade,
    handleCidade,
    estado,
    handleEstado,
  };
};

export default useFilters;
